// extracted by mini-css-extract-plugin
export var blockBtn = "courseTopics-module--block-btn--eb5b1";
export var courseTopics = "courseTopics-module--course-topics--9fc70";
export var courseTopics__info = "courseTopics-module--course-topics__info--be544";
export var courseTopics__topicCard = "courseTopics-module--course-topics__topic-card--1faf9";
export var courseTopics__topicCardImg = "courseTopics-module--course-topics__topic-card-img--98e99";
export var courseTopics__topicCards = "courseTopics-module--course-topics__topic-cards--04eb3";
export var courseTopics__wrapper = "courseTopics-module--course-topics__wrapper--e8f78";
export var mainBtn = "courseTopics-module--main-btn--ebdb4";
export var mainTitle = "courseTopics-module--main-title--c483d";